import { memo, useCallback } from 'react';

import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@doger/ui/components/ui/dialog';

import { AddNoteForm } from './add-note-form.component';
import styles from './add-note-modal.module.scss';

type AddNoteModalProps = {
  userId: string;
  isOpen: boolean;
  onClose: () => void;
};

export const AddNoteModal = memo<AddNoteModalProps>(
  ({ userId, isOpen, onClose }) => {
    const onSubmit = useCallback(() => {
      onClose();
    }, [onClose]);

    return (
      <Dialog open={isOpen} onOpenChange={onClose}>
        <DialogContent className={styles.dialogContent}>
          <DialogHeader>
            <DialogTitle>Add Note</DialogTitle>
          </DialogHeader>

          <DialogBody className={styles.content}>
            <AddNoteForm
              userId={userId}
              onSubmit={onSubmit}
              onCancel={onClose}
            />
          </DialogBody>
        </DialogContent>
      </Dialog>
    );
  }
);
